import { callWithNuxt } from "#app";

interface myFetchOptions {
  headers?: Record<string, string>;
  [key: string]: any;
}

const getBaseUrl = () => {
  let baseURL = '';
  const config = useRuntimeConfig();
  if (process.env.NODE_ENV === 'production') {
    //生产环境
    if (import.meta.server) {
      //SSR请求内网
      baseURL = config.localHost ?? "";
    } else {
      baseURL = config.domain ?? "";
    }
  } else {
    //本地开发环境
    baseURL = config.localHost ?? "";
  }
  return baseURL;
}
export const useHttpFetch =  <T>(url: string, opt: myFetchOptions) => {
  //token
  const accessToken = useCookie('accessToken');
  //添加请求头和token
  const headers = {
      ...opt.headers,
      ...(accessToken.value ? {Authorization: `Bearer ${accessToken.value}`} : {})
  }
  opt.headers = headers;
  const nuxtApp = useNuxtApp();
  return $fetch<T>(url, {
    ...opt,
    credentials: 'include',
    baseURL: getBaseUrl(),//基本url
    onRequest({request, options}) { },
    onRequestError({ request, options, error }) { },
    async onResponse({ request, response, options }) { 

    },
    async onResponseError({ request, response, options }) {
      //未登录401状态
      if (response.status === 401) {
        await callWithNuxt(nuxtApp, navigateTo, [
          "/login", {
            replace:true, 
            redirectCode:302 
          }
        ]);
        let token = useCookie("accessToken");
        token.value = null;
        // let user = useCookie("userInfo");
        // user.value = null;
        throw new Error(response._data.msg || '响应错误');
      } else if (response.status === 500) {
        throw new Error(response._data.msg || '服务错误');
      } else if (response.status === 400) {
        throw new Error(response._data.msg || '参数错误');
      }
    }
  })
}

// 登录接口
export const loginFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>('/api/auth/login', opt);
}

// 验证码接口
export const captchaFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>('/api/captcha', opt);
}

// 组织接口
export const orgFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>('/api/org', opt);
}

// 下拉枚举接口
export const enumFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>(`/api/enum/${opt.routeQuery}`, opt);
}

// 单据类型接口
export const billTypeFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>(`/api/billtype/${opt.routeQuery}`, opt);
}

// 用户信息接口
export const userFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>(`/api/auth/user`, opt);
}

// 修改密码接口
export const passwordFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>('/api/auth/password', opt);
}

// 单据类型接口
export const materialFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>(`/api/material/${opt.routeQuery}`, opt);
}

// 单位接口
export const unitFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>('/api/unit', opt);
}

// 询价需求单保存接口
export const xjdSaveFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>('/api/requisition/save', opt);
}

// 询价单按用户查询接口
export const quotationFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>(`/api/quotation/${opt.routeQuery}`, opt);
}

// 询价单所有用户数据查询接口
export const quotationAllFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>(`/api/quotation`, opt);
}

// 询价单保存接口
export const quotationSaveFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>('/api/quotation/save', opt);
}

// 文件上传接口
export const uploadFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>('/api/upload', opt);
}

// 币别接口
export const currencyFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>('/api/currency', opt);
}

// 用户注册后台校验
export const userRegisterFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>('/api/validator/user', opt);
}

// 用户注册保存
export const userSaveFetch = (opt: myFetchOptions) => {
  return useHttpFetch<any>('/api/auth/user', opt);
}